module.exports = __webpack_public_path__ + "static/media/war.34a4aacf.png";